export const trimStockCompany = (customerName?: string) => {
  const regex = /(株式会社|㈱|\(株\)|（株）)/g;
  return customerName?.replace(regex, '')?.trim() ?? '';
};
